module.exports = __webpack_public_path__ + "static/img/landmark-product-title.f834408.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landmark-product-title.png
// module id = 507
// module chunks = 1